// Share only pending reads. Settled responses are never retained.
const pending = new Map();
let revision = 0;

export function invalidatePendingReads() { revision += 1; pending.clear(); }

export function sharePendingRead(key, request) {
  const scopedKey = `${revision}:${key}`;
  if (pending.has(scopedKey)) return pending.get(scopedKey);
  const task = Promise.resolve().then(request).finally(() => {
    if (pending.get(scopedKey) === task) pending.delete(scopedKey);
  });
  pending.set(scopedKey, task);
  return task;
}

export function isShareableRead(url) {
  return /^\/api\/v1\/(stock-finder\/(preferences|favorite-folder\/list)|portfolio\/(list|open_positions\/[^/?]+)|portfolio-preferences|portfolio-invest-preferences|stocks\/fundamental\/[^/?]+)$/.test(url);
}
